import isDate from 'lodash.isdate';
import moment from 'moment';

type DateType = number | string | ReturnType<typeof moment> | Date;

const formatDate = (
    date: DateType | undefined,
    outputFormat: string = 'DD-MMM-YYYY',
    /**
     * Format for Moment
     * */
    inputFormat?: string,
): string => {
    if (typeof date === 'number') {
        return moment({
            year: date,
        }).format(outputFormat);
    } else if (moment.isMoment(date)) {
        return moment(date).format(outputFormat);
    } else if (isDate(date) || typeof date === 'string') {
        return inputFormat
            ? moment(date, inputFormat).format(outputFormat)
            : moment(date).format(outputFormat);
    } else {
        return '';
    }
};

const toQuarter = (
    quarter: string | number | undefined,
    year: number,
): string => (
    quarter
        ? moment({year}).format(`${quarter}[Q]YY`)
        : ''
);

export {formatDate, toQuarter};
